import * as React from 'react';
import {useContext, useState, useEffect, useRef} from 'react';
import {ProductContext} from "../../../../pages/ProductStencil";
import {useI18N} from "../../../../my-puratos/hoc/withI18N";

export function Details() {
    const translate = useI18N();
    const {product} = useContext(ProductContext);
    const descriptionRef = useRef(null);
    const [isExpanded, setIsExpanded] = useState(true);
    const [showButton, setShowButton] = useState(false);

    useEffect(() => {
        if (!descriptionRef.current) return;
        const parent = document.getElementById("details");
        const parentHeight = parent ? parent.offsetHeight : 0;
        const descriptionHeight = descriptionRef.current.offsetHeight;

        if (descriptionHeight >= parentHeight*0.5) {
            descriptionRef.current.style.setProperty('--hiddenContentHeight', `${descriptionHeight / 2}px`);
            setShowButton(true);
            setIsExpanded(false);
        } else {
            setShowButton(false);
        }
    }, [descriptionRef]);

    const expandText = () => {
        if (descriptionRef.current) {
            descriptionRef.current.scrollIntoView({behavior: "smooth"});
        }
        setIsExpanded(!isExpanded);
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLAnchorElement>) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            expandText();
        }
    };

    return (
        <div id="details" className='details'>
            <div
                ref={descriptionRef}
                aria-expanded={isExpanded}
                aria-controls="product-details"
                aria-description={translate("Product description")}
                className={`${isExpanded || !showButton ? "details__description" : "details__description details__description--hidden"}`}
                dangerouslySetInnerHTML={{__html: product.description}}>
            </div>
            {showButton && (
                <a
                    className="details__button"
                    onClick={expandText}
                    role={"button"}
                    tabIndex={0}
                    onKeyDown={handleKeyDown}
                    aria-label={isExpanded ? translate("View less") : translate("View full description")}
                >
                    {isExpanded ? translate("View less") : translate("View full description")}
                </a>
            )}
            {product.benefits && product.benefits.length > 0 && (
                <ul className="details__benefits">
                    {product.benefits.map((benefit, index) => (
                        <li key={index} className="details__benefit">{benefit}</li>
                    ))}
                </ul>
            )}
        </div>
    );
}
